import {
  USER_SELECT_FETCH_STARTED,
  USER_SELECT_FETCH_SUCCEEDED,
  USER_SELECT_FETCH_FAILED,
  USER_SELECT_CLEAR
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  users: [],
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case USER_SELECT_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case USER_SELECT_FETCH_SUCCEEDED:
      return {
        ...state,
        status: statuses.succeeded,
        users: action.payload
      };
    case USER_SELECT_FETCH_FAILED:
      return { ...state, status: statuses.failed, users: [], error: action.error };
    case USER_SELECT_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
